"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredTokenFields = exports.CREDIT_ITEM_KEY = void 0;
const enums_1 = require("./enums");
exports.CREDIT_ITEM_KEY = 'credit_item_key';
exports.RequiredTokenFields = new Map([
    [enums_1.CognitoTokenFields.TenantId, false],
    [enums_1.CognitoTokenFields.TenantSlug, false],
    [enums_1.CognitoTokenFields.Username, false],
    [enums_1.CognitoTokenFields.Role, false],
    [enums_1.CognitoTokenFields.Code, false],
    [enums_1.CognitoTokenFields.GivenName, false],
    [enums_1.CognitoTokenFields.FamilyName, false],
    [enums_1.CognitoTokenFields.Email, true],
    [enums_1.CognitoTokenFields.Iss, true],
    [enums_1.CognitoTokenFields.Sub, true],
]);
